import React from "react"
import { Star } from "lucide-react"

const Stars = ({ label }) => {
  const n = parseInt(label, 10) || 0
  return (
    <span className="inline-flex items-center gap-0.5">
      {Array.from({ length: n }).map((_, i) => (
        <Star key={i} size={12} className="fill-[#FFA94D] text-[#FFA94D]" />
      ))}
    </span>
  )
}

export default Stars
